<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title class="headline">
        <slot name="title">
          {{ options.title ? options.title : $t('Are you sure?') }}
        </slot>
      </v-card-title>

      <v-card-text>
        <slot name="text">
          {{ options.text ? options.text : '' }}
        </slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn color="red darken-1" text @click="onClose(true)">
          {{ $t('Yes') }}
        </v-btn>

        <v-btn color="grey darken-1" text @click="onClose(false)">
          {{ $t('No') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationModal',

  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    dialog: true
  }),

  methods: {
    onClose (value) {
      this.$emit('onCloseModal')
      this.options.onClose(value)
    }
  }
}
</script>
